import axios from "axios";
import { networkTimeoutThreshold } from "./config";

export default (endpoint, payload = {}, method = "get", headers = {}) => {
  const axiosConfig = {
    headers,
    method: method.toLowerCase(),
    timeout: networkTimeoutThreshold,
  };
  if (method === "get") {
    axiosConfig.params = payload;
  } else {
    axiosConfig.data = payload;
  }

  return axios(`${endpoint}`, axiosConfig);
};
